import {createAction, props} from '@ngrx/store';
import {Update} from '@ngrx/entity';

import {CitizenVerifyPhoneNumber} from './citizen-verify-phone-number.model';

export const loadCitizenVerifyPhoneNumbers = createAction(
  '[CitizenVerifyPhoneNumber/API] Load CitizenVerifyPhoneNumbers',
  props<{ citizenVerifyPhoneNumbers: CitizenVerifyPhoneNumber[] }>()
);

export const addCitizenVerifyPhoneNumber = createAction(
  '[CitizenVerifyPhoneNumber/API] Add CitizenVerifyPhoneNumber',
  props<{ citizenVerifyPhoneNumber: CitizenVerifyPhoneNumber }>()
);

export const upsertCitizenVerifyPhoneNumber = createAction(
  '[CitizenVerifyPhoneNumber/API] Upsert CitizenVerifyPhoneNumber',
  props<{ citizenVerifyPhoneNumber: CitizenVerifyPhoneNumber }>()
);

export const addCitizenVerifyPhoneNumbers = createAction(
  '[CitizenVerifyPhoneNumber/API] Add CitizenVerifyPhoneNumbers',
  props<{ citizenVerifyPhoneNumbers: CitizenVerifyPhoneNumber[] }>()
);

export const upsertCitizenVerifyPhoneNumbers = createAction(
  '[CitizenVerifyPhoneNumber/API] Upsert CitizenVerifyPhoneNumbers',
  props<{ citizenVerifyPhoneNumbers: CitizenVerifyPhoneNumber[] }>()
);

export const updateCitizenVerifyPhoneNumber = createAction(
  '[CitizenVerifyPhoneNumber/API] Update CitizenVerifyPhoneNumber',
  props<{ citizenVerifyPhoneNumber: Update<CitizenVerifyPhoneNumber> }>()
);

export const updateCitizenVerifyPhoneNumbers = createAction(
  '[CitizenVerifyPhoneNumber/API] Update CitizenVerifyPhoneNumbers',
  props<{ citizenVerifyPhoneNumbers: Update<CitizenVerifyPhoneNumber>[] }>()
);

export const deleteCitizenVerifyPhoneNumber = createAction(
  '[CitizenVerifyPhoneNumber/API] Delete CitizenVerifyPhoneNumber',
  props<{ id: string }>()
);

export const deleteCitizenVerifyPhoneNumbers = createAction(
  '[CitizenVerifyPhoneNumber/API] Delete CitizenVerifyPhoneNumbers',
  props<{ ids: string[] }>()
);

export const clearCitizenVerifyPhoneNumbers = createAction(
  '[CitizenVerifyPhoneNumber/API] Clear CitizenVerifyPhoneNumbers'
);


//CUSTOM

// citizenVerifyPhoneNumber

export const citizenVerifyPhoneNumber = createAction(
  '[CitizenVerifyPhoneNumber/API] citizen Verify Phone Number',
  props<{ userPhoneNumber: string }>()
);
